/**
 * WP Rocket: sluit noDelay.min.js uit bij “Delay JavaScript”.
 * Algolia vendor wordt hier geladen (niet als aparte <script> in de HTML) zodat die ook niet wordt vertraagd.
 */
(function () {
	var cfg = window.strl_no_delay;
	var url = cfg && cfg.algolia_vendor_url;
	if (!url) {
		return;
	}
	var s = document.createElement('script');
	s.src = url;
	s.async = false;
	s.setAttribute('data-strl-algolia-vendor', '1');
	(document.head || document.documentElement).appendChild(s);
})();
